import React from 'react';
import { Divider } from 'antd';
import { Column, Row, Text, Icon } from '../../common';
import { GREEN_DARK } from '../../../utils/colors'

export const NotificationContent = ({ orderId }) => {
    const success = {
        title: 'Nueva orden ingresada',
        color: '#22A889',
        icon: 'bell-solid',
        backgroundColor: '#E6F5F1',
        borderColor: '#B6DFD6'
    };    

    const { msg, icon, color, title } = success;

    return <Row align='center'>
        <Icon name={icon} size={24} color={color} />
        <Divider type='vertical' style={{ background: color, height: '3em', margin: '0px 14px 0px 14px', width: '0.15em', top: 0 }} />
        <Column style={{ lineHeight: '17px' }}>
            <Text text={title} size={14} style={{ marginBottom: 7 }} color={color} semibold />
            <Column>
                <Text text={<div>
                    El pedido <strong>{orderId}</strong> está pendiente de asignación.
                </div>} size={12} />
                <a
                    href={`/orders/${orderId}`}
                    target='_blank'
                    style={{ cursor: 'pointer', color }}
                >
                    <Text text='Ir al pedido' size={12} style={{ textDecoration: 'underline' }} strong color={GREEN_DARK} />
                </a>
            </Column>
        </Column>
    </Row>
};